<template>
  <div id="footer" chrome-app-version="1.2.1">
    <div v-if="false" class="container-fluid about">
      <div class="container">
        <div class="row">
          <div class="col-md-3 col-sm-6 col-xs-6">
            <dl>
              <dt>服务与支持</dt>
              <dd>
                <router-link :to="{ name: 'content' }">睿客网使用服务协议</router-link>
              </dd>
              <dd>
                <router-link :to="{ name: 'faq' }">睿客网FAQ文档</router-link>
              </dd>
              <dd>
                <a data-target="#feedback" data-toggle="modal">意见反馈</a>
              </dd>
            </dl>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-6">
            <dl>
              <dt>应用</dt>
              <dd>
                <router-link :to="{ name: 'recdrive' }">
                  <i class="iconfont icon-logo"></i>
                  云盘
                </router-link>
              </dd>
              <dd>
                <router-link :to="{ name: 'grouplist' }">
                  <i class="iconfont icon-system-group"></i>
                  群组
                </router-link>
              </dd>
              <dd>
                <router-link :to="{ name: 'persona' }">
                  <i class="iconfont icon-system-more"></i>
                  更多
                </router-link>
              </dd>
            </dl>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-6">
            <dl>
              <dt>睿客网客户端</dt>
              <dd>
                <router-link :to="{ name: 'download' }">
                  <i class="iconfont icon-windows"></i>Windows
                </router-link>
              </dd>
              <dd>
                <router-link :to="{ name: 'downloadAndroid' }">
                  <i class="iconfont icon-android"></i>Android
                </router-link>
              </dd>
              <dd>
                <router-link :to="{ name: 'downloadIphone' }">
                  <i class="iconfont icon-ios1"></i>iPhone
                </router-link>
              </dd>
              <dd>
                <router-link :to="{ name: 'download' }">
                  <i class="iconfont icon-system-more"></i>
                  更多
                </router-link>
              </dd>
              <!-- <dd>
                <router-link :to="{ name: 'downloadWindowsSync' }">
                  <i class="iconfont icon-windows-tb"></i>Windows同步端
                </router-link>
              </dd>
              <dd>
                <router-link :to="{ name: 'downloadIphoneSync' }">
                  <i class="iconfont icon-ios-tb"></i>Mac同步端
                </router-link>
              </dd> -->
            </dl>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-6">
            <dl>
              <dt>友情链接</dt>
              <dd>
                <a href="http://v.ucas.ac.cn" target="_blank">中科院实景课堂</a>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid copyright">
      <div class="container">
        <p>
          ©2014-{{ year }} 中国科学技术大学 版权所有 |
          网络信息中心：中国合肥金寨路96号，电话：0551-63600800，服务邮箱：
          <a href="mailto:rec@ustc.edu.cn">rec@ustc.edu.cn</a>
        </p>
        <p>为了浏览体验，请使用chrome浏览器</p>
      </div>
    </div>
    <Feedback></Feedback>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data () {
    return {
      year: new Date().getFullYear(),
    };
  },
  components: {
    Feedback: () => import("./Feedback"),
  },
};
</script>

<style scoped></style>